/* @ngInject */
function boardsService (ConnectorWebService, CONSTANTS, Utils) {
  var service = {
    getTasksMetrics,
    getBoards,
    deleteBoard,
    createBoards,
    updateBoard,
    duplicateBoard,
    getBoardById,
    getBoardTasks,
    getTaskDefaultBoard,
    getArchivedTasks,
    getTasksRequesters
  }
  return service

  function getBoards (top = 100, skip, search = '', $sort = '', $order = 'ASC', isArchived = false) {
    let url = CONSTANTS.URL_BOARDS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if ($sort || $order) {
      url = Utils.fnAddQueryToUrl(url, { $sort, $order })
    }

    if (isArchived !== null) {
      url = Utils.fnAddQueryToUrl(url, { isArchived })
    }

    return ConnectorWebService.get(url)
  }

  function getTaskDefaultBoard (taskId) {
    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_BOARDS_TASKS_DEFAULT, { taskId })
    return ConnectorWebService.get(url)
  }

  function deleteBoard (sId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID, [sId])
    return ConnectorWebService.fnDelete(sUrl)
  }

  function createBoards (board) {
    const payload = {
      description: board.description,
      deliveryDate: board.deliveryDate,
      users: board.members,
      icon: board.icon,
      name: board.name,
      workingDays: board.workingDays,
      moveAutomatically: board.moveAutomatically,
      allowUserComment: board.allowUserComment
    }

    return ConnectorWebService.post(CONSTANTS.URL_BOARDS, payload)
  }

  function updateBoard (sId, board) {
    const payload = {
      description: board.description,
      deliveryDate: board.deliveryDate,
      users: board.members,
      icon: board.icon,
      name: board.name,
      workingDays: board.workingDays,
      moveAutomatically: board.moveAutomatically,
      allowUserComment: board.allowUserComment
    }

    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID, [sId])
    return ConnectorWebService.put(sUrl, payload)
  }

  function duplicateBoard (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID_DUPLICATE, [id])
    return ConnectorWebService.post(url)
  }

  function getBoardById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID, [id])
    return ConnectorWebService.get(url)
  }

  function getBoardTasks (id, top, skip, filtersParam, sort, search) {
    const filters = {
      ...filtersParam
    }
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID_TASKS, [id])

    Object.keys(filters).forEach(key => {
      if (Array.isArray(filters[key]) && !filters[key].length) {
        delete filters[key]
      }
    })

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (filters && filters.assignees && Array.isArray(filters.assignees)) {
      const assignees = filters.assignees.map(assignee => {
        if (typeof assignee === 'object') {
          return assignee.id
        }

        return assignee
      })

      delete filters.assignees
      url = Utils.addQueryStringFromArray(url, 'assignees', assignees)
    }

    if (filters) {
      url = Utils.fnAddQueryToUrl(url, filters)
    }

    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function getArchivedTasks (id, top, skip, sort, search, isUser) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID_ARCHIVED, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search: search })
    }
    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
    }

    url = Utils.fnAddQueryToUrl(url, { isUser })

    return ConnectorWebService.get(url)
  }

  function getTasksMetrics (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID_TASKS_METRICS, [id])
    return ConnectorWebService.get(url)
  }

  function getTasksRequesters (id, options = {}) {
    const {
      search,
      top: $top,
      skip: $skip
    } = options
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARDS_ID_TASKS_REQUESTERS, [id])

    if ($top) {
      url = Utils.fnAddQueryToUrl(url, { $top })
    }

    if ($skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }
}

export { boardsService }
